import {
  getConversations as getConversationsApi,
  showConversation as showConversationApi,
  getMessages as getMessagesApi,
  createMessage as createMessageApi
} from './api'

let getConversations = (params) => dispatch => {
  return getConversationsApi(params)
}

let showConversation = (conversationId) => dispatch => {
  return showConversationApi(conversationId)
}

let getMessages = (conversationId, params) => dispatch => {
  return getMessagesApi(conversationId, params)
}

let createMessage = (conversationId, data) => dispatch => {
  return createMessageApi(conversationId, data)
}

export {
  getConversations,
  showConversation,
  getMessages, 
  createMessage
}
